module.exports = __webpack_public_path__ + "static/fonts/roboto-v32-cyrillic_cyrillic-ext_latin_latin-ext-300italic.3149bba.eot";